import { useTranslation } from "react-i18next";

import { HeadingTwo } from "@/components/ui/typography/HeadingTwo";
import { Paragraph } from "@/components/ui/typography/Paragraph";
import { Button } from "@/components/ui/Button";
import { IStateItemProps } from "./types";
import { useNavigate } from "@tanstack/react-router";

export const StateMessage = ({
  title,
  subtitle,
  btn,
  img,
  btnIcon,
  route,
}: IStateItemProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-5 gap-16 items-center max-w-6xl">
      <div className="col-span-2">
        <img src={img} className="w-full h-auto" />
      </div>
      <div className="col-span-3">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-4">
            <HeadingTwo>{t(title)}</HeadingTwo>
            <Paragraph>{t(subtitle)}</Paragraph>
          </div>
          {btn && (
            <Button
              className="max-w-fit"
              onClick={() => navigate({ to: route })}
            >
              <div className="flex gap-4 items-center">
                {btnIcon && btnIcon}
                {t(btn)}
              </div>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
